// extracted by mini-css-extract-plugin
module.exports = {"account":"Account_account__3qaT_"};